import { useQuery } from '@tanstack/react-query';

import { orderClient, restClient } from 'src/lib/api';

export const useGetAllFleets = () => {
  const query = useQuery({
    queryKey: ['getAllFleetDetails'],
    queryFn: () => restClient.get('getAllFleetDetails').then((res) => res?.data),
  });

  return query;
};

export const useGetSlotsForTruck = (truckSize, truckType) => {
  const query = useQuery({
    queryKey: ['useGetSlotsForTruck', truckSize, truckType],
    queryFn: () =>
      orderClient
        .get('api/v1/order/getTimeSlots', {
          params: {
            truckType,
            truckSize,
          },
        })
        .then((res) => res?.data),
    enabled: !!truckSize && !!truckType,
  });

  return query;
};
